import { apiRequest } from '@common/api/utils';

async function getProfileSharableStats() {
  return apiRequest(
    'GET', '/referrals/profile-shareable/',
  );
}

async function getMoonshotLinks(payload) {
  return apiRequest(
    'POST', '/referrals/profile-shareable/', payload,
  );
}

export default {
  getProfileSharableStats,
  getMoonshotLinks,
};
